import React, {FC, useState} from "react";
import { Input } from "@jane/lib/src/components/form/Input";
import {Select} from "../../../lib/src/components/form/Select";
import { useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {useToasts} from "../../../lib/src/toasts/toasts";
import {ContractStartFlowTrigger, CalendarWeekFlowTrigger} from "../../../lib/src/api/repositories/flows-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AddFlowModal: FC<{onFinish: () => void}> = (props) => {
  const {flows} = useApiCall(config)
  const flowTriggerOptions = {
    'contract_start': {
      name: 'Startdatum contract',
      defaultParams: {
        days_offset: 0,
      } as ContractStartFlowTrigger['params'],
    },
    'calendar_week': {
      name: 'Kalenderweek',
      defaultParams: {
        week_number: 1,
      } as CalendarWeekFlowTrigger['params'],
    },
  }
  const [name, setName] = useState('')
  const [trigger, setTrigger] = useState<keyof typeof flowTriggerOptions>('contract_start')
  const {showToast} = useToasts()
  const submit = async () => {
    await flows.addFlow(name, trigger, flowTriggerOptions[trigger].defaultParams).then(() => {
      showToast('Aangemaakt', 'Flow aangemaakt')
    }).catch(() => {
      showToast('Oeps', 'Er is iets misgegaan bij het aanmaken van de flow')
    })
  }

  const selectOptions = Object.fromEntries(Object.entries(flowTriggerOptions).map(([key, value]) => [key, value.name]))

  return <div className={"flex flex-col space-y-3"}>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Select label={'Trigger'} options={selectOptions} value={trigger} onChange={(e) => setTrigger(e as keyof typeof flowTriggerOptions)} />
    <ModalFooter text={'Flow aanmaken'} isDisabled={name.length < 3} onSubmit={async () => {
      await submit()
      close()
      props.onFinish()
    }} />
  </div>
}
